import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, Observable, of, switchMap } from 'rxjs';
import { PlatformsService } from '../data/services/platforms.service';
import { LocalStorageService } from '../data/services/localStorage.service';

@Injectable({ providedIn: 'root' })
export class CanActivateGuard {

  constructor(
    private msalService: MsalService,
    private router: Router,
    private msalBroadcastService: MsalBroadcastService,
    private platformService: PlatformsService,
    private localStorageService: LocalStorageService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    // Guardamos la URL solicitada
   // localStorage.setItem('storedAuth', 'H4EMxZw/FhZlnDuzpzACZqv0ua3KaRMQjApkHirHphE=');






    // ------------------------------------------------------------------
    // ✔ FLUJO ESPECIAL PARA WEBVIEW NATIVO (iOS + Android)
    // ------------------------------------------------------------------
    if (this.platformService.isIOs() || this.platformService.isEmbeddedApp()) {
      const session = this.localStorageService.getSessionToken();
      if (session?.hash) {
        return true;
      }

      // /auth/login is not a registered route (auth routes live at root).
      // Use /login-failed which IS defined in features/auth/routes.ts.
      this.router.navigate(['/login-failed']);
      return false;
    }
    this.msalService.loginPopup();

    return false;
    // ------------------------------------------------------------------
    // ✔ FLUJO NORMAL PARA BROWSER / ANDROID (MSAL)
    // ------------------------------------------------------------------

    return this.msalBroadcastService.inProgress$
      .pipe(
        filter(status => status === InteractionStatus.None),
        switchMap(() => {
          const accounts = this.msalService.instance.getAllAccounts();

          if (accounts.length > 0) {
            return of(true);
          }

          this.router.navigate(['/auth/login']);
          return of(false);
        })
      );
  }
}
